import { BannerCTA } from "./BannerCTA";

export class BannerData {
  /**
   * 
   * @param {[BannerCTA]} values 
   */
  constructor(id, values, customData) {
    this.id = id;
    this.values = values;
    this.customData = customData;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new BannerData(
        input.id,
        BannerCTA.fromApiArray(input.values),
        input.data
      )
    }

    return new BannerData();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => BannerData.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [BannerData.fromApiObject(input)];
    }

    return [];
  }
}